// API base URL for Bible data
const API_BASE_URL = '/api';

/**
 * Helper function to make API requests
 */
async function apiRequest(endpoint, params = {}) {
  try {
    const url = API_BASE_URL + '/' + endpoint;
    let fullUrl = url;

    // Add query parameters
    const paramStrings = [];
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        paramStrings.push(`${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`);
      }
    });
    if (paramStrings.length > 0) {
      fullUrl += '?' + paramStrings.join('&');
    }

    console.log('Making API request to:', fullUrl);
    const response = await fetch(fullUrl);
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error(`API request failed: ${endpoint}`, error);
    throw error;
  }
}

/**
 * Get all available Bible translations, optionally filtered by language
 * @param {string} language - Optional language code to filter translations
 */
export async function getBibles(language) {
  return await apiRequest('bibles', { language });
}

/**
 * Get books for a specific Bible translation
 */
export async function getBooks(bibleId) {
  return await apiRequest('books', { bibleId });
}

/**
 * Get chapters for a specific book in a Bible translation
 */
export async function getChapters(bibleId, bookId) {
  return await apiRequest('chapters', { bibleId, bookId });
}

/**
 * Get verses for a specific chapter reference (e.g., "GEN.1")
 */
export async function getVerses(bibleId, chapterRef) {
  return await apiRequest('verses', { bibleId, chapterRef });
}

/**
 * Get text for a specific verse reference (e.g., "GEN.1.1")
 */
export async function getVerseText(bibleId, verseRef) {
  const result = await apiRequest('verse', { bibleId, verseRef });
  return result ? result.text : null;
}

// Cache for verse text to improve performance
const verseTextCache = new Map();

/**
 * Get cached verse text or fetch it
 */
export async function getCachedVerseText(bibleId, verseRef) {
  const cacheKey = `${bibleId}:${verseRef}`;

  if (verseTextCache.has(cacheKey)) {
    return verseTextCache.get(cacheKey);
  }

  const text = await getVerseText(bibleId, verseRef);
  verseTextCache.set(cacheKey, text);
  return text;
}
